/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * API For public part of application: Inzerce movitého majetku
 * This API provides endpoints for public part: Inzerce movitého majetku
 * OpenAPI spec version: v1
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";

import type {
	ClientError,
	GetApiAssetsadvertAdvertisementsParams,
	GetApiAssetsadvertMap200,
	GetApiAssetsadvertMapParams,
	IFrameAssetsAdvertDto,
	IFrameAssetsAdvertDtoPaginatedCollection,
} from "../aPIForPublicPartOfApplicationInzerceMovitéhoMajetku.schemas";

import { restAxiosFetcher } from "../../restAxiosFetcher";
import type { ErrorType } from "../../restAxiosFetcher";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieves a paginated list of asset advertisements for the iframe view, based on the provided filter criteria and sorting options.
 */
export const getApiAssetsadvertAdvertisements = (
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<IFrameAssetsAdvertDtoPaginatedCollection>(
		{ url: `/api/assetsadvert/advertisements`, method: "GET", params, signal },
		options,
	);
};

export const getGetApiAssetsadvertAdvertisementsQueryKey = (params?: GetApiAssetsadvertAdvertisementsParams) => {
	return [`/api/assetsadvert/advertisements`, ...(params ? [params] : [])] as const;
};

export const getGetApiAssetsadvertAdvertisementsQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsadvertAdvertisementsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>> = ({ signal }) =>
		getApiAssetsadvertAdvertisements(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsadvertAdvertisementsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>
>;
export type GetApiAssetsadvertAdvertisementsQueryError = ErrorType<unknown>;

export function useGetApiAssetsadvertAdvertisements<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params: undefined | GetApiAssetsadvertAdvertisementsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertAdvertisements<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertAdvertisements<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a paginated list of asset advertisements for the iframe view, based on the provided filter criteria and sorting options.
 */

export function useGetApiAssetsadvertAdvertisements<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsadvertAdvertisementsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves a paginated list of asset advertisements for the iframe view, based on the provided filter criteria and sorting options.
 */
export const prefetchGetApiAssetsadvertAdvertisementsQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	queryClient: QueryClient,
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetsadvertAdvertisementsQueryOptions(params, options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetsadvertAdvertisementsSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsadvertAdvertisementsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>> = ({ signal }) =>
		getApiAssetsadvertAdvertisements(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsadvertAdvertisementsSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>
>;
export type GetApiAssetsadvertAdvertisementsSuspenseQueryError = ErrorType<unknown>;

export function useGetApiAssetsadvertAdvertisementsSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params: undefined | GetApiAssetsadvertAdvertisementsParams,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertAdvertisementsSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertAdvertisementsSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a paginated list of asset advertisements for the iframe view, based on the provided filter criteria and sorting options.
 */

export function useGetApiAssetsadvertAdvertisementsSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>,
	TError = ErrorType<unknown>,
>(
	params?: GetApiAssetsadvertAdvertisementsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertAdvertisements>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsadvertAdvertisementsSuspenseQueryOptions(params, options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves a map of advertisement counts grouped by region based on the provided filter criteria.
 */
export const getApiAssetsadvertMap = (
	params?: GetApiAssetsadvertMapParams,
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<GetApiAssetsadvertMap200>(
		{ url: `/api/assetsadvert/map`, method: "GET", params, signal },
		options,
	);
};

export const getGetApiAssetsadvertMapQueryKey = (params?: GetApiAssetsadvertMapParams) => {
	return [`/api/assetsadvert/map`, ...(params ? [params] : [])] as const;
};

export const getGetApiAssetsadvertMapQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsadvertMapQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsadvertMap>>> = ({ signal }) =>
		getApiAssetsadvertMap(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsadvertMapQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAssetsadvertMap>>>;
export type GetApiAssetsadvertMapQueryError = ErrorType<ClientError>;

export function useGetApiAssetsadvertMap<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params: undefined | GetApiAssetsadvertMapParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsadvertMap>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertMap<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsadvertMap>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertMap<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a map of advertisement counts grouped by region based on the provided filter criteria.
 */

export function useGetApiAssetsadvertMap<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsadvertMapQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves a map of advertisement counts grouped by region based on the provided filter criteria.
 */
export const prefetchGetApiAssetsadvertMapQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	queryClient: QueryClient,
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetsadvertMapQueryOptions(params, options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetsadvertMapSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsadvertMapQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsadvertMap>>> = ({ signal }) =>
		getApiAssetsadvertMap(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsadvertMapSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAssetsadvertMap>>>;
export type GetApiAssetsadvertMapSuspenseQueryError = ErrorType<ClientError>;

export function useGetApiAssetsadvertMapSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params: undefined | GetApiAssetsadvertMapParams,
	options: {
		query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertMapSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertMapSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a map of advertisement counts grouped by region based on the provided filter criteria.
 */

export function useGetApiAssetsadvertMapSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertMap>>,
	TError = ErrorType<ClientError>,
>(
	params?: GetApiAssetsadvertMapParams,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertMap>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsadvertMapSuspenseQueryOptions(params, options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves a single asset advertisement for the iframe view by its identifier.
 */
export const getApiAssetsadvertId = (
	id: number,
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<IFrameAssetsAdvertDto>(
		{ url: `/api/assetsadvert/${encodeURIComponent(String(id))}`, method: "GET", signal },
		options,
	);
};

export const getGetApiAssetsadvertIdQueryKey = (id: number) => {
	return [`/api/assetsadvert/${id}`] as const;
};

export const getGetApiAssetsadvertIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsadvertIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsadvertId>>> = ({ signal }) =>
		getApiAssetsadvertId(id, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsadvertId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsadvertIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAssetsadvertId>>>;
export type GetApiAssetsadvertIdQueryError = ErrorType<ClientError>;

export function useGetApiAssetsadvertId<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsadvertId>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsadvertId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertId<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsadvertId>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsadvertId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertId<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a single asset advertisement for the iframe view by its identifier.
 */

export function useGetApiAssetsadvertId<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsadvertIdQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves a single asset advertisement for the iframe view by its identifier.
 */
export const prefetchGetApiAssetsadvertIdQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	queryClient: QueryClient,
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetsadvertIdQueryOptions(id, options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetsadvertIdSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsadvertIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsadvertId>>> = ({ signal }) =>
		getApiAssetsadvertId(id, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsadvertId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsadvertIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAssetsadvertId>>>;
export type GetApiAssetsadvertIdSuspenseQueryError = ErrorType<ClientError>;

export function useGetApiAssetsadvertIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options: {
		query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsadvertIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a single asset advertisement for the iframe view by its identifier.
 */

export function useGetApiAssetsadvertIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsadvertId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsadvertId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsadvertIdSuspenseQueryOptions(id, options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}
